import React from "react";
import { Form, Row, Col, Button, InputGroup } from "react-bootstrap";
import { CiSearch } from "react-icons/ci";
import Select from "react-select";
import { setIpFilterForm } from "../../../slices/IpSettings/ipSettingsSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  setActiveTab,
  setPaginationPageNumber,
  TriggerFilterButtonApi,
} from "../../../slices/common/reducer";

function IpSettingsFilter() {
  const filterForm = useSelector((state) => state.ipSettings.filter.form);
  const dispatch = useDispatch();

  const handleInputChange = (name, value) => {
    dispatch(setIpFilterForm({ name, value }));
    resetTabAndPageNumber();
    dispatch(TriggerFilterButtonApi());
  };

  const resetTabAndPageNumber = () => {
    dispatch(setPaginationPageNumber(0));
    dispatch(setActiveTab("ALL"));
  };

  const handleClear = () => {
    dispatch(setIpFilterForm({ type: "reset" }));

    dispatch(TriggerFilterButtonApi());

    if (Object.keys(filterForm).length > 0) {
      resetTabAndPageNumber();
    }
  };

  const ipOptions = [
    { value: "ACTIVE", label: "Active" },
    { value: "INACTIVE", label: "Inactive" },
  ];

  const isClearButtonDisabled = !Object.values(filterForm).some(
    (value) => value
  );

  return (
    <div className="filter-wrapper">
      <Form className="form-input">
        <Row>
          <Form.Group as={Col} className="col-md-6">
            <InputGroup>
              <InputGroup.Text id="basic-addon1">
                {" "}
                <CiSearch />
              </InputGroup.Text>
              <Form.Control
                type="text"
                placeholder="Search for IP..."
                name="ip_address"
                id="ip_address"
                className="org-searchbar"
                value={filterForm.ip_address || ""}
                onChange={(e) =>
                  handleInputChange(e.target.name, e.target.value)
                }
              />
            </InputGroup>
          </Form.Group>
          <Form.Group as={Col} className="col-md-6">
            <Select
              isClearable
              placeholder="Status"
              name="status"
              options={ipOptions}
              value={
                ipOptions.find((itm) => itm.value === filterForm.status) || null
              }
              onChange={(e) => handleInputChange("status", e ? e.value : "")}
            />
          </Form.Group>
          {/* <Form.Group as={Col} className="col-md-1">
            <div>
              <Button
                className="primary-outline"
                onClick={handleClear}
                disabled={isClearButtonDisabled}
              >
                Clear
              </Button>
            </div>
          </Form.Group> */}
        </Row>
      </Form>
    </div>
  );
}

export default IpSettingsFilter;
